//CRN_20260508 - Riskline Travel Search v2 PULL API
//             - Endpoint: POST https://api.riskline.com/services/travel-search/v2 (proxied via SureSim backend)

import { RisklineCategoryDTO } from './riskline-category.dto';
import { RisklineRiskLevelDTO } from './riskline-risk-level.dto';

//#region Request

export interface TravelSearchRequestDTO {
  dateOutbound: string;
  dateReturn  : string;
  destination : string;
  nationality?: string;
  origin      : string;
}

export function TravelSearchRequestDTO_EmptyObject(): TravelSearchRequestDTO {
  return {
    dateOutbound: '',
    dateReturn  : '',
    destination : '',
    nationality : '',
    origin      : ''
  };
}

//#endregion

//#region Response - Trip risk level / Facts / Entry borders

export interface TravelSearchTripRiskLevelDTO {
  description: string;
  id         : string;
  info       : string;
  name       : string;
}

export interface TravelSearchFactsDTO {
  capital      : string;
  currency_name: string;
  languages    : string;
  time_zone    : string;
}

export interface TravelSearchEntryBordersDTO {
  borders: string;
  status : string;
  text   : string;
}

//#endregion

//#region Response - Possible disruptions

export interface TravelSearchAlertSummaryDTO {
  category?  : RisklineCategoryDTO;
  end_date   : string;
  id         : string;
  risk_level : RisklineRiskLevelDTO;
  start_date : string;
  title      : string;
}

export interface TravelSearchAdvisorySummaryDTO {
  id        : string;
  risk_level: RisklineRiskLevelDTO;
  text      : string;
  title     : string;
}

export interface TravelSearchEventDTO {
  date       : string;
  iso_dates ?: string | string[];
  name       : string;
}

export interface TravelSearchPossibleDisruptionsDTO {
  advisories?: TravelSearchAdvisorySummaryDTO[];
  alerts?    : TravelSearchAlertSummaryDTO[];
  events?    : TravelSearchEventDTO[];
}

//#endregion

//#region Response - Travel documentation / Vaccinations / Health docs

export interface TravelSearchPassportRequirementsDTO {
  additional_info               : string;
  entry_possible_with_passport_x: string;
  exceptions                    : string;
  validity                      : string;
}

export interface TravelSearchVisaCheckerDTO {
  disclaimer       : string;
  is_visa_required : string;
  text             : string;
}

export interface TravelSearchAppDTO {
  android_url: string;
  huawei_url : string;
  ios_url    : string;
  name       : string;
}

export interface TravelSearchTravelDocumentDTO {
  app              : TravelSearchAppDTO;
  document_form_url: string;
  id               : string;
  kind             : string;
  name             : string;
  text             : string;
  weight           : number;
}

export interface TravelSearchTravelDocumentationDTO {
  passport_requirements?: TravelSearchPassportRequirementsDTO;
  travel_documents?     : TravelSearchTravelDocumentDTO[];
  visa_checker?         : TravelSearchVisaCheckerDTO;
}

export interface TravelSearchVaccinationDTO {
  id              : string;
  name            : string;
  recommended_for : 'all' | 'most' | 'some' | string;
  text            : string;
  weight          : number;
}

export interface TravelSearchHealthDocumentDTO {
  app              : TravelSearchAppDTO;
  document_form_url: string;
  id               : string;
  kind             : string;
  name             : string;
  text             : string;
  weight           : number;
}

//#endregion

//#region Response - Female / LGBTQ travellers

export interface TravelSearchAssessmentDTO {
  description    : string;
  level          : number;
  level_computed : string;
  level_name     : string;
}

export interface TravelSearchTravellerElementDTO {
  key   : string;
  label : string;
  text  : string;
  weight: number;
}

export interface TravelSearchTravellerSectionDTO {
  elements?: TravelSearchTravellerElementDTO[];
  name     : string;
}

export interface TravelSearchFemaleTravellersDTO {
  assessment?         : TravelSearchAssessmentDTO;
  health_and_wellness?: TravelSearchTravellerSectionDTO;
  law_and_customs?    : TravelSearchTravellerSectionDTO;
  name                : string;
  safety?             : TravelSearchTravellerSectionDTO;
}

export interface TravelSearchLgbtqTravellersDTO {
  assessment?: TravelSearchAssessmentDTO;
  elements?  : TravelSearchTravellerElementDTO[];
  name       : string;
}

//#endregion

//#region Response - Top-level

export interface TravelSearchMetaDTO {
  documents_disclaimer?: string;
  language?            : string;
}

export interface TravelSearchResponseDTO {
  entry_borders         : TravelSearchEntryBordersDTO;
  facts                 : TravelSearchFactsDTO;
  female_travellers?    : TravelSearchFemaleTravellersDTO;
  health_documentation? : TravelSearchHealthDocumentDTO[];
  lgbtq_travellers?     : TravelSearchLgbtqTravellersDTO;
  meta                  : TravelSearchMetaDTO;
  possible_disruptions? : TravelSearchPossibleDisruptionsDTO;
  travel_documentation? : TravelSearchTravelDocumentationDTO;
  trip_risk_level       : TravelSearchTripRiskLevelDTO;
  vaccinations?         : TravelSearchVaccinationDTO[];
}

//#endregion
